import { ChargingStationStatus } from '@energy-stacks/broker/feature-charging-stations-data';
import { Theme } from '@mui/material/styles';
import { colors } from '@mui/material';

interface ChargingStationShadowStatus {
  bgColor: string;
  color: string;
}

export const chargingStationStatusDisplay: (theme: Theme) => {
  [status in ChargingStationStatus]: ChargingStationShadowStatus;
} = (theme: Theme) =>
  ({
    undefined: {
      bgColor: 'grey.200',
      color: 'grey.700',
    },
    available: {
      bgColor: 'success.light',
      color: 'success.dark',
    },
    charging: {
      bgColor: 'primary.light',
      color: 'primary.dark',
    },
    reserved: {
      bgColor: 'warning.light',
      color: 'warning.dark',
    },
    faulted: {
      bgColor: 'orange.light',
      color: 'error.dark',
    },
    unavailable: {
      bgColor: 'grey.300',
      color: 'grey.900',
    },
    occupied: {
      bgColor: 'cyan.50',
      color: 'cyan.500',
    },
    finishing: {
      bgColor: 'cyan.50',
      color: 'cyan.500',
    },
    preparing: {
      bgColor: colors.indigo[50],
      color: colors.indigo[600],
    },
    suspendedEV: {
      bgColor: 'pink.50',
      color: 'pink.600',
    },
    suspendedEVSE: {
      bgColor: 'secondary.light',
      color: 'secondary.main',
    },
    provisioned: {
      bgColor: 'orange.100',
      color: 'orange.900',
    },
  } satisfies Record<ChargingStationStatus, ChargingStationShadowStatus>);
